import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import exporter from "../../static/assets/Exporter.svg";

const TableActionsColumn = ({ onExportPdf, onExportCsv, onSendEmail }) => {
  const { t } = useTranslation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  return (
    <div
      className="table-standard-row-cell table-standard-row-actions"
      ref={dropdownRef}
    >
      <button
        type="button"
        className="char-button"
        style={{ height: "36px" }}
        onClick={(e) => {
          e.stopPropagation();
          setIsDropdownOpen(!isDropdownOpen);
        }}
      >
        <img src={exporter} alt="export" className="char-button-icon" />
        {t("Export")}
      </button>
      {isDropdownOpen && (
        <div className="char-dropdown">
          {onExportPdf && (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onExportPdf();
                setIsDropdownOpen(false);
              }}
              className="char-dropdown-item"
            >
              <img
                src={exporter}
                alt="export"
                className="char-dropdown-item-icon"
              />
              <span>{t("PDF")}</span>
            </button>
          )}
          {onExportCsv && (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onExportCsv();
                setIsDropdownOpen(false);
              }}
              className="char-dropdown-item"
            >
              <img
                src={exporter}
                alt="export"
                className="char-dropdown-item-icon"
              />
              <span>{t("CSV")}</span>
            </button>
          )}
          {(onExportPdf || onExportCsv) && onSendEmail && (
            <div className="char-dropdown-item-divider" />
          )}
          {onSendEmail && (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                onSendEmail();
                setIsDropdownOpen(false);
              }}
              className="char-dropdown-item"
            >
              <i className="fas fa-envelope char-text-secondary" />
              <span>{t("Send by email")}</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default TableActionsColumn;
